// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-1252f8e0] {\n  position: relative;\n  width: 100vw;\n  background-color: #000;\n}\n.main .content[data-v-1252f8e0] {\n  margin: 0 auto;\n  max-width: 480px;\n  min-height: 100%;\n  background-color: #fff;\n  overflow: hidden;\n  position: relative;\n}\n[data-v-1252f8e0] .van-action-sheet {\n  z-index: 2002;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
